import "./style.css";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { RiArrowDownSLine } from "react-icons/all";

const faqSections = [
  {
    title: "O CapitalPay",
    items: [
      {
        question: "Šta je CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay je vaš digitalni novčanik, kreiran da vam omogući
              plaćanja i transfere novca putem telefona 24/7, bez potrebe da
              svaki put idete na šalter.
            </p>
            <p>
              CapitalPay je proizvod IFJB Capital SH.P.K., institucije
              licencirane od strane Centralne banke Kosova.
            </p>
            <p>
              Uz CapitalPay možete plaćati račune i vršiti plaćanja prema
              biznisima, primati i slati novac, a istovremeno pratiti svoje
              transakcije i upravljati novcem lakše, brže i sigurnije.
            </p>
          </>
        ),
      },
      {
        question: "Zašto koristiti CapitalPay?",
        answer: (
          <>
            <p>
              CapitalPay vam štedi vreme i omogućava pristup plaćanjima gde god
              da se nalazite. Ne morate čekati u redu, nositi račune sa sobom
              ili fizički odlaziti na lokaciju za svako plaćanje.
            </p>
            <p>
              Putem aplikacije možete vršiti plaćanja 24/7, direktno sa svog
              telefona.
            </p>
          </>
        ),
      },
      {
        question: "Koje usluge mogu obaviti putem CapitalPay?",
        answer: (
          <>
            <p>Putem CapitalPay možete vršiti plaćanja za:</p>
            <ul>
              <li>kazne policije;</li>
              <li>internet i TV;</li>
              <li>račune za vodu;</li>
              <li>poreze i doprinose;</li>
              <li>druga domaća plaćanja;</li>
              <li>plaćanja u prodavnicama/biznisima;</li>
              <li>transfere novca;</li>
              <li>dopunu računa.</li>
            </ul>
            <p>
              Lista usluga može se vremenom ažurirati, u zavisnosti od novih
              usluga koje se dodaju u aplikaciju.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Otvaranje računa",
    items: [
      {
        question: "Kako mogu otvoriti račun u CapitalPay?",
        answer: (
          <>
            <p>Za otvaranje računa:</p>
            <ul>
              <li>Preuzmite aplikaciju CapitalPay.</li>
              <li>Unesite svoj broj telefona.</li>
              <li>Potvrdite kod koji dobijete putem SMS-a.</li>
              <li>Popunite tražene podatke.</li>
              <li>Završite verifikaciju identiteta.</li>
              <li>Sačekajte odobrenje računa.</li>
            </ul>
            <p>Nakon odobrenja, možete početi koristiti CapitalPay.</p>
          </>
        ),
      },
      {
        question: "Šta mi je potrebno za registraciju?",
        answer: (
          <>
            <p>Za registraciju su vam potrebni:</p>
            <ul>
              <li>aktivan broj telefona;</li>
              <li>e-mail adresa;</li>
              <li>identifikacioni dokument;</li>
              <li>fotografija/selfie za verifikaciju;</li>
              <li>dokaz o adresi stanovanja.</li>
            </ul>
            <p>
              Podaci moraju biti tačni, a dokument mora biti važeći.
            </p>
          </>
        ),
      },
      {
        question: "Da li mogu otvoriti poslovni račun u CapitalPay?",
        answer: (
          <>
            <p>
              Da. Uz CapitalPay možete kreirati i račun za svoj biznis.
            </p>
            <p>
              Poslovni račun vam omogućava da primate uplate od klijenata putem
              CapitalPay, na jednostavan i siguran način.
            </p>
          </>
        ),
      },
      {
        question: "Da li mogu koristiti CapitalPay sa brojem van Kosova?",
        answer: (
          <p>
            Trenutno se CapitalPay može koristiti samo sa kosovskim brojem
            telefona sa prefiksom +383. Aplikaciji CapitalPay može se pristupiti
            iz svake države u Evropi.
          </p>
        ),
      },
    ],
  },
  {
    title: "Verifikacija",
    items: [
      {
        question: "Zašto je potrebna verifikacija identiteta?",
        answer: (
          <p>
            Verifikacija se vrši radi vaše sigurnosti i radi sprečavanja
            zloupotrebe računa. Ovo je neophodan korak za digitalne finansijske
            usluge.
          </p>
        ),
      },
      {
        question: "Koliko traje odobrenje računa?",
        answer: (
          <p>
            Odobrenje može trajati u zavisnosti od opterećenja i tačnosti
            podataka koje ste dostavili. Ako su dokumenti jasni i podaci tačni,
            proces se obično završava veoma brzo.
          </p>
        ),
      },
      {
        question: "Da li račun može biti odbijen?",
        answer: (
          <>
            <p>Račun možda neće biti odobren ako:</p>
            <ul>
              <li>dokument nije jasan;</li>
              <li>fotografija se ne poklapa sa dokumentom;</li>
              <li>podaci su uneti pogrešno;</li>
              <li>dokument je istekao;</li>
              <li>nedostaje neka potrebna informacija.</li>
            </ul>
            <p>
              U tom slučaju može se tražiti ispravka podataka ili ponovno
              dostavljanje dokumenata.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Dopuna računa",
    items: [
      {
        question: "Kako mogu dopuniti račun?",
        answer: (
          <>
            <p>
              Da biste dopunili svoj CapitalPay račun, možete koristiti jedan od
              sledećih načina:
            </p>
            <p>1. U poslovnicama Capital</p>
            <ul>
              <li>Posetite jednu od poslovnica Capital na Kosovu.</li>
              <li>
                Obavestite operatera da želite da dopunite svoj CapitalPay
                račun.
              </li>
              <li>
                Potrebno je da imate identifikacioni dokument, kao što su lična
                karta, pasoš ili vozačka dozvola.
              </li>
              <li>
                Predajte iznos kojim želite dopuniti račun i sredstva će odmah
                biti prebačena na vaš CapitalPay račun.
              </li>
            </ul>
            <p>Bez provizije, na više od 200 lokacija širom Kosova.</p>
            <p>2. Putem bankovnog transfera</p>
            <ul>
              <li>
                Otvorite eBanking ili mBanking svoje banke i izaberite opciju
                “Nacionalni transfer” ili sličan naziv, u zavisnosti od banke.
              </li>
              <li>
                U polje računa primaoca unesite IBAN vašeg CapitalPay računa.
              </li>
              <li>
                U opisu možete napisati “transfer” ili “dopuna računa”.
              </li>
            </ul>
            <p>
              Nakon što CapitalPay primi sredstva, ona će odmah biti prebačena
              na vaš elektronski račun.
            </p>
            <p>
              Bankovni transferi se obrađuju u skladu sa rokovima banke
              pošiljaoca i međubankarskog sistema.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Povlačenje sredstava sa računa",
    items: [
      {
        question: "Kako mogu povući sredstva sa računa?",
        answer: (
          <>
            <p>
              Da biste povukli sredstva sa svog CapitalPay računa, možete
              koristiti jedan od sledećih načina:
            </p>
            <p>1. U poslovnicama Capital</p>
            <ul>
              <li>Posetite jednu od poslovnica Capital na Kosovu.</li>
              <li>
                Obavestite operatera da želite da povučete novac sa svog
                CapitalPay računa.
              </li>
              <li>
                Potrebno je da imate identifikacioni dokument, kao što su lična
                karta, pasoš ili vozačka dozvola.
              </li>
            </ul>
            <p>
              Naknada za povlačenje sredstava sa CapitalPay računa u bilo kojoj
              poslovnici Capital iznosi samo 0,50 €.
            </p>
            <p>2. Putem bankovnog transfera</p>
            <ul>
              <li>Na početnoj stranici kliknite na dugme “Povlačenje”.</li>
              <li>
                Dodajte bankovni račun na koji želite da prebacite svoja
                sredstva. Unesite tačne podatke računa popunjavanjem prikazanih
                polja.
              </li>
              <li>
                Nakon što kreirate račun, možete izabrati taj račun za transfer
                sredstava izborom računa primaoca.
              </li>
              <li>
                Popunite tražene podatke i kliknite na dugme za nastavak. Zatim
                će se prikazati prozor za potvrdu transfera, gde možete
                proveriti da li su svi podaci tačni pre završetka povlačenja.
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: "Plaćanja",
    items: [
      {
        question: "Kako se plaća račun u CapitalPay?",
        answer: (
          <>
            <p>
              Račun možete platiti skeniranjem barkoda ili QR koda putem opcije
              za skeniranje na početnoj stranici.
            </p>
            <p>Ili:</p>
            <p>Na početnoj stranici izaberite opciju “Platite račune”.</p>
            <ul>
              <li>Izaberite kategoriju plaćanja.</li>
              <li>Unesite tražene podatke.</li>
              <li>Proverite iznos i podatke.</li>
              <li>Potvrdite plaćanje.</li>
            </ul>
          </>
        ),
      },
      {
        question: "Kako mogu platiti u prodavnicama?",
        answer: (
          <>
            <p>
              Nakon što izaberete opciju “Plaćanje u prodavnicama” na početnoj
              stranici:
            </p>
            <ol>
              <li>
                Izaberite prodavnicu za koju želite da platite, pretragom po
                nazivu ili izborom iz liste.
              </li>
              <li>Platite skeniranjem QR koda postavljenog u prodavnici.</li>
              <li>Platite putem broja telefona prodavnice.</li>
            </ol>
          </>
        ),
      },
      {
        question: "Gde mogu pronaći dokaz o uplati?",
        answer: (
          <p>
            Dokaz o uplati možete pronaći na početnoj stranici ili u istoriji
            transakcija.
          </p>
        ),
      },
      {
        question: "Da li mogu otkazati plaćanje nakon potvrde?",
        answer: (
          <p>
            U većini slučajeva, potvrđena plaćanja ne mogu se otkazati. Ako ste
            napravili grešku, odmah kontaktirajte podršku CapitalPay.
          </p>
        ),
      },
    ],
  },
  {
    title: "Transferi",
    items: [
      {
        question: "Da li mogu slati ili primati novac putem CapitalPay?",
        answer: (
          <>
            <p>
              Da. CapitalPay omogućava slanje i primanje novca od drugog
              CapitalPay korisnika putem broja telefona, broja računa ili QR
              koda.
            </p>
            <p>Takođe možete transferisati novac i na bankovne račune.</p>
          </>
        ),
      },
    ],
  },
  {
    title: "Pristup aplikaciji",
    items: [
      {
        question: "Kako se prijavljujem u CapitalPay?",
        answer: (
          <p>
            U aplikaciju se možete prijaviti pomoću broja telefona i lozinke
            koju ste postavili.
          </p>
        ),
      },
      {
        question: "Da li mogu ući pomoću Face ID-a ili otiska prsta?",
        answer: (
          <p>
            Da. Ako vaš telefon podržava ovu funkciju, možete aktivirati
            biometrijsku identifikaciju za brži i sigurniji pristup.
          </p>
        ),
      },
      {
        question: "Zaboravio/la sam lozinku. Šta treba da uradim?",
        answer: (
          <p>
            Koristite opciju “Resetuj lozinku” u aplikaciji putem SMS-a ili
            e-maila, ili kontaktirajte podršku.
          </p>
        ),
      },
      {
        question:
          "Promenio/la sam telefon. Da li mogu ponovo pristupiti svom računu?",
        answer: (
          <p>
            Da. Preuzmite aplikaciju na novi telefon i prijavite se pomoću svog
            broja telefona.
          </p>
        ),
      },
    ],
  },
  {
    title: "Naknade",
    items: [
      {
        question: "Da li postoji naknada za otvaranje računa?",
        answer: <p>Otvaranje računa je besplatno.</p>,
      },
      {
        question: "Da li postoji mesečna naknada za održavanje?",
        answer: (
          <p>
            CapitalPay nema mesečnu naknadu za održavanje računa. Naknade se
            mogu primenjivati samo za određene usluge, prema zvaničnom
            cenovniku.
          </p>
        ),
      },
      {
        question: "Gde mogu videti naknade?",
        answer: (
          <p>
            Naknade treba da budu prikazane pre potvrde transakcije ili u
            zvaničnom cenovniku CapitalPay. Pre nego što izvršite plaćanje,
            proverite da li se primenjuje neka naknada.
          </p>
        ),
      },
    ],
  },
  {
    title: "Sigurnost",
    items: [
      {
        question: "Da li je CapitalPay siguran?",
        answer: (
          <>
            <p>
              Da. CapitalPay koristi sigurnosne mere za zaštitu vašeg računa,
              podataka i transakcija.
            </p>
            <p>
              Za veću sigurnost, ne delite ni sa kim svoju lozinku ili
              verifikacioni kod koji primite putem SMS-a.
            </p>
          </>
        ),
      },
      {
        question: "Šta treba da uradim ako sumnjam na zloupotrebu?",
        answer: (
          <p>
            Ako primetite nepoznate transakcije ili sumnjate da neko ima
            pristup vašem računu, odmah kontaktirajte podršku CapitalPay.
          </p>
        ),
      },
    ],
  },
  {
    title: "Podrška",
    items: [
      {
        question: "Kako mogu dobiti pomoć?",
        answer: (
          <>
            <p>
              Za pomoć u vezi sa CapitalPay, možete kontaktirati podršku putem
              zvaničnih kanala:
            </p>
            <ul>
              <li>Tel: 038 600 003</li>
              <li>Email: info@capital-ks.com</li>
            </ul>
            <p>
              Podrška vam može pomoći oko registracije, verifikacije, plaćanja,
              transfera, pristupa računu i eventualnih tehničkih problema.
            </p>
          </>
        ),
      },
    ],
  },
];

function FrequentlyAskedQuestionsSR() {
  return (
    <div id="wrapper-page">
      <div id="first_page">
        <h1>Pomoć / Često postavljana pitanja</h1>
        {faqSections.map((section) => (
          <div key={section.title} className="faq-section">
            <h2>{section.title}</h2>
            <Accordion allowZeroExpanded>
              {section.items.map((item) => (
                <AccordionItem key={item.question}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      {item.question}
                      <RiArrowDownSLine />
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>{item.answer}</AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FrequentlyAskedQuestionsSR;
